// フロントエンド設定
const config = {
  // バージョン
  version: '1.0.0',
  // apis送信定義
  api: {
    // api送信タイムアウト(ミリ秒)
    timeout: 1200000,
  },
  // ユーザー定義
  users: {
    download: {
      // ダウンロード処理開始sleep(ミリ秒)
      runStartSleep: 0,
    },
  },
  common: {
    focus: {
      // focus開始までのwait時間(ミリ秒)
      startWait: 0,
    },
  },
}

export default config
